import { batchTailClamps, tailClamp } from './tailClamp'

const expandGroups = new Map()

function registerExpandGroup(element, options, api) {
  const groupName = typeof options.expandGroup === 'string' ? options.expandGroup.trim() : ''
  if (groupName === '' || typeof api?.expand !== 'function') return

  const toggle = element.querySelector('[data-clamp-toggle]')
  if (!(toggle instanceof HTMLElement)) return

  const group = expandGroups.get(groupName) || []
  group.push(api)
  expandGroups.set(groupName, group)

  toggle.addEventListener('click', () => {
    if (toggle.getAttribute('aria-expanded') !== 'true') return

    group.forEach((candidateApi) => {
      if (candidateApi !== api) candidateApi.expand()
    })
  })
}

export function initTailClamps(root = document) {
  const elements = Array.from(root.querySelectorAll('[data-tail-clamp]'));
  if (root.matches?.('[data-tail-clamp]')) elements.unshift(root);

  batchTailClamps(() => elements.forEach(function(element) {
    if (element.dataset.tailClampInitialized) return;

    try {
      const options = JSON.parse(element.dataset.tailClamp);
      const api = tailClamp(element, options);
      element.dataset.tailClampInitialized = 'true';
      registerExpandGroup(element, options, api);
    } catch (error) {
      console.warn('TailClamp initialization failed:', error, element);
    }
  }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initTailClamps());
} else {
  initTailClamps();
}
